import React from 'react';
import {
  Typography,
  Wrap,
  Select,
  Button,
  Input,
  BackButton,
  Loader,
} from '../../components/index';
import { Row, Col } from 'react-styled-flexboxgrid';
import { useParams, useNavigate } from 'react-router-dom';
import _ from 'lodash';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { scrollToTop, useResponsivity } from '../../helpers/helpers';
import Washroom from './Washroom';
import Kitchen from './Kitchen/Kitchen';
import { formatWashroomAnswers } from '../../helpers/formatWashroomAnswers';
import { formatKitchenAnswers } from '../../helpers/formatKitchenAnswers';
interface AddRoomProps {
  questions: any;
  getQuestions: Function;
  addRoom: Function;
  clearAnswerKey: Function;
  room: any;
}

const AddRoom: React.FC<AddRoomProps> = (props) => {
  const { questions, room, getQuestions, addRoom, clearAnswerKey } = props;
  const { loading, done, error } = props.questions.status;

  const { locationId } = useParams();
  const [refresh, setRefresh] = React.useState(false);
  const navigate = useNavigate();
  const addRoomDone = _.get(room, 'addRoom.status.done');
  const addRoomLoading = _.get(room, 'addRoom.status.loading');

  const data = props.questions.answers;
  const isMobile = useResponsivity();
  React.useEffect(() => {
    if (!refresh) return;

    const timeId = setTimeout(() => {
      setRefresh(false);
      setRoom('');
      setRoomAnswers({});
      clearAnswerKey();
    }, 3000);

    return () => {
      clearTimeout(timeId);
    };
  }, [refresh]);
  const roomType = [
    { label: 'Washroom', value: 'washroom' },
    { label: 'Kitchen', value: 'kitchen' },
  ];
  const [selectRoom, setRoom] = React.useState('');
  const [roomAnswers, setRoomAnswers] = React.useState({});

  React.useEffect(() => {
    if (!selectRoom || !roomAnswers) return;
  }, [roomAnswers, selectRoom]);

  const handleRoomType = (e) => {
    const room = e.target.value;

    setRoom(room);
    clearAnswerKey();
    getQuestions(room);

    setRoomAnswers({});
  };
  React.useEffect(() => {
    if (selectRoom) {
      scrollToTop();
    }
  }, [selectRoom]);

  const renderMessage = () => {
    return (
      <Col md={12} sm={12} xs={12}>
        <Typography
          size="p"
          style={{ textAlign: 'center', marginTop: '32px', fontWeight: 600 }}
          text="You have not selected any room. Please select a room in order to see the questions."
        />
      </Col>
    );
  };
  const AddRoomSchema = Yup.object().shape({
    name: Yup.string().required('Required'),
  });
  const renderForm = () => {
    return (
      <Formik
        initialValues={{
          name: '',
        }}
        validationSchema={AddRoomSchema}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(false);
          console.log('ROOM ANSWERS', roomAnswers);
          const formattedData =
            selectRoom === 'washroom'
              ? formatWashroomAnswers(roomAnswers)
              : formatKitchenAnswers(roomAnswers);

          console.log(formattedData);

          addRoom(locationId, selectRoom, values.name, formattedData);

          setRefresh(true);
          scrollToTop();
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting,
          /* and other goodies */
        }) => {
          return (
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
              <Row>
                <Col xs={12} sm={12} md={6}>
                  <Input
                    id="name"
                    name="name"
                    value={values.name}
                    type="text"
                    placeholder="Room name e.g. Ground floor"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      errors.name && touched.name ? errors.name : undefined
                    }
                  />
                </Col>
                <Col xs={12} sm={12} md={6}>
                  <Select
                    onChange={handleRoomType}
                    value={selectRoom}
                    options={roomType}
                    name="room"
                    placeholder="Choose the type of your room"
                  />
                </Col>

                {loading && <Loader />}
                {error && (
                  <Typography
                    size="p"
                    style={{
                      textAlign: 'center',
                      marginTop: '32px',
                      fontWeight: 600,
                    }}
                    text="There was a problem with"
                  />
                )}

                {questions.data && selectRoom !== '' && !loading ? (
                  <Col xs={12} md={12} sm={12}>
                    {selectRoom === 'washroom' ? (
                      <Washroom onChange={setRoomAnswers} />
                    ) : (
                      <Kitchen onChange={setRoomAnswers} />
                    )}
                  </Col>
                ) : (
                  renderMessage()
                )}
                {selectRoom === '' || loading ? null : (
                  <Col
                    md={12}
                    sm={12}
                    xs={12}
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      flexDirection: isMobile ? 'column' : 'row',
                    }}
                  >
                    <Button
                      disabled={isSubmitting}
                      isLoading={addRoomLoading}
                      type="submit"
                    >
                      Create room
                    </Button>
                  </Col>
                )}
              </Row>
            </form>
          );
        }}
      </Formik>
    );
  };

  return (
    <Wrap>
      <Row>
        <Col md={12} sm={12} xs={12}>
          <Typography
            size="1"
            text="Add room"
            style={{ marginBottom: '32px' }}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12} sm={12} xs={12} style={{ marginBottom: '32px' }}>
          <BackButton />
        </Col>
      </Row>
      <Row>
        {addRoomDone && refresh ? (
          <Col md={12} sm={12} xs={12}>
            <Typography
              size="4"
              style={{
                textAlign: 'center',
                marginTop: '32px',
                fontWeight: 600,
              }}
              text="Success!"
            />
            <Typography
              size="p"
              style={{
                textAlign: 'center',
                marginTop: '32px',
                fontWeight: 400,
              }}
              text="New room created"
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '32px',
                flexDirection: isMobile ? 'column' : 'row',
              }}
            >
              <Button
                style={{
                  marginRight: '16px',
                  marginBottom: isMobile ? '16px' : '0px',
                }}
                onClick={() => navigate('/portal')}
              >
                Home
              </Button>
              <Button
                onClick={() => {
                  setRefresh(false);
                  clearAnswerKey();
                  setRoom('');
                }}
                style={{ marginRight: '16px' }}
              >
                Create new room
              </Button>
            </div>
          </Col>
        ) : (
          <Col md={12} sm={12} xs={12}>
            {renderForm()}
          </Col>
        )}
      </Row>
    </Wrap>
  );
};

export default AddRoom;
